module.exports = __webpack_public_path__ + "img/section2Bg1.7a9d134c.webp";